import React, { useState } from 'react';
import { API_BASE_URL } from '../config';

const defaultQuestions = [
  "What if everyone jumped at once?",
  "What if the Earth stopped spinning?",
  "What if you tried to hit a baseball pitched at 90% the speed of light?",
  "What if you had a mole of moles?",
  "What if you could teleport anywhere instantly?"
];

function SuggestedQuestions({ onQuestionClick, user, onAuthRequired, credits, onDeductCredits }) {
  const [suggestedQuestions, setSuggestedQuestions] = useState(defaultQuestions);
  const [isGenerating, setIsGenerating] = useState(false);

  const generateNewQuestions = async () => {
    if (!user) {
      onAuthRequired();
      return;
    }

    // Check if user has enough credits for question generation
    if (credits < 10) {
      alert('Not enough credits. You need 10 credits to generate new questions.');
      return;
    }

    setIsGenerating(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/random-questions`);
      const data = await response.json();
      
      if (response.ok && data.questions) {
        setSuggestedQuestions(data.questions);
        // Deduct credits for question generation
        await onDeductCredits(10);
      }
    } catch (error) {
      console.error('Failed to generate new questions:', error);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-xl font-mono font-bold mb-4">
          Try these absurd questions:
        </h2>
        <button
          onClick={generateNewQuestions}
          disabled={isGenerating}
          className="plain-link text-sm disabled:opacity-50"
        >
          {isGenerating ? "Generating..." : "Generate new questions"}
        </button>
      </div>
      
      <div className="space-y-2">
        {suggestedQuestions.map((question, index) => (
          <div key={index} className="text-center">
            <button
              onClick={() => onQuestionClick(question)}
              className="plain-link text-lg hover:text-muted"
            >
              {question}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SuggestedQuestions; 